import * as THREE from "three";

export class Map {
  constructor(store, parent) {
    this.store = store;
    this.parent = parent;
    this.group = new THREE.Group();
    this.parent.add(this.group);
    this.meshGroup = new THREE.Group();
    this.group.add(this.meshGroup);
    this.model = null;
    this.load();
  }

  async load() {
    this.model = this.store.assetManager.getModel("map");
    this.model.scale.setScalar(2.6);
    this.model.userData.type = "map";
    this.model.userData.instance = this;
    //CLICKABLES TÖMBBŐL NEM TÖRÖLHETŐ
    this.model.userData.baseObject = true;
    const box = new THREE.Box3().setFromObject(this.model);
    const center = new THREE.Vector3();
    box.getCenter(center);
    this.model.position.sub(center);
    this.model.traverse((child) => {
      if (child.isMesh) {
        child.castShadow = true;
        child.receiveShadow = true;
        child.material.color.set("#BFD9CC");
      }
    });
    this.meshGroup.add(this.model);
    this.store.input.clickables.push(this.model);
    this.group.updateWorldMatrix(true, true);
    this.store.loading.hide()
  }

  update() {
    if (!this.model) { return; }
    this.group.updateWorldMatrix(true, true);
  }


  getWorldPosition() {return this.group.getWorldPosition(new THREE.Vector3());}

  dispose() {
    this.parent.remove(this.group);
  }

  getWorldBounds() {

    this.group.updateWorldMatrix(true, true);

    const box = new THREE.Box3().setFromObject(this.group);

    const center = box.getCenter(new THREE.Vector3());

    return {
        min: box.min.clone(),
        max: box.max.clone(),
        center: center.clone(),

        corners: {
            minMinMin: new THREE.Vector3(
                box.min.x,
                box.min.y,
                box.min.z
            ),

            maxMinMin: new THREE.Vector3(
                box.max.x,
                box.min.y,
                box.min.z
            ),

            minMaxMin: new THREE.Vector3(
                box.min.x,
                box.max.y,
                box.min.z
            ),

            maxMaxMin: new THREE.Vector3(
                box.max.x,
                box.max.y,
                box.min.z
            ),

            minMinMax: new THREE.Vector3(
                box.min.x,
                box.min.y,
                box.max.z
            ),

            maxMinMax: new THREE.Vector3(
                box.max.x,
                box.min.y,
                box.max.z
            ),

            minMaxMax: new THREE.Vector3(
                box.min.x,
                box.max.y,
                box.max.z
            ),

            maxMaxMax: new THREE.Vector3(
                box.max.x,
                box.max.y,
                box.max.z
            )
        }
    };
}

}